module.exports = __webpack_public_path__ + "static/media/wiadomosci.bc6b04a2.svg";